export default "__VITE_ASSET__By9$Ya93__"